import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./index.module.less";
// 错误边界组件
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error("BaseCompanyBlock Error:", error, errorInfo);
    }
    render() {
        const errDom = process.env.NODE_ENV === "production" ? (_jsx(_Fragment, {})) : (_jsx("div", { className: styles.errorFallback, children: _jsxs("div", { className: styles.errorMessage, children: [_jsx("span", { children: "Component Render Error" }), _jsx("button", { type: "button", onClick: () => this.setState({ hasError: false, error: null }), className: styles.retryBtn, children: "Reset" })] }) }));
        if (this.state.hasError) {
            return this.props.fallback || errDom;
        }
        return this.props.children;
    }
}
